import { render } from "./warranty-activation.vue?vue&type=template&id=13cf3ec1&scoped=true"
import script from "./warranty-activation.vue?vue&type=script&lang=js"
export * from "./warranty-activation.vue?vue&type=script&lang=js"

import "./warranty-activation.vue?vue&type=style&index=0&id=13cf3ec1&lang=scss&scoped=true"
import "./warranty-activation.vue?vue&type=style&index=1&id=13cf3ec1&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13cf3ec1"]])

export default __exports__